import { EnvironmentFooter } from './environment.footer';

const footer: EnvironmentFooter = {
  social: {
    facebook: 'https://www.facebook.com/propero',
    twitter: 'https://twitter.com/propero',
    instagram: 'https://www.instagram.com/propero',
    linkedin: 'https://www.linkedin.com/company/propero',
  },
  stores: {
    googlePlay: 'https://play.google.com/store/apps/details?id=io.propero.app',
    appStore: '',
  },
};

export const environment = {
  production: true,

  backend: 'https://app.itwiththebest.com:1102',
  assistantApp: 'https://admin.propero.io',
  backendImmoReport: 'https://app.itwiththebest.com:1102',
  stripePublishableKey:
    'pk_live_51RIR5VCpAr4uGistKMcfHFgQouVJqDsVaNJwP0p1pGmiWPvGf2XBB5LzOx9gb3xPqYZeRnZxwQAsL5jGbUA5Jve500Mr7uyW6e',
  baseUrl: 'https://propero.io',

  dateFormat: 'dd-MM-yyyy',

  fakeLogin: false,
  debug: true,
  info: true,
  error: true,
  log: true,

  footer,

  company: {
    name: "SC LogicLand SRL", //{{PARAM_COMPANY_NAME}}
    j: "",                    //{{PARAM_COMPANY_J}}
    cui: "",
    management: "s",
    registerLocation: "s2",
    website: "propero.io",
    address: {
      no: "",
      street: "",
      building: "",
      floor: "",
      apartament: "",
      city: "",
      county: "",
      country: ""
    },
    contactInfo: {
      person: "",
      telephone: "",
      email: "",
      contactTelephone: "+40 743 366 261",
      contactEmail: "contact@propero.io",
      privacyEmail: "privacy@propero.io",
      salesEmail: "sales@propero.io",
      dpoEmail: "dpo@propero.io",
    }
  },

  

  
  
};
